import React from 'react';
import Sidebar from './Sidebar';

/**
 * USOKIE Platform Page Loading Component
 * Shared component for full-page loading states
 * Design: Black (#000), Bone (#fffbf7), Sage (#a1c6a2)
 */

const monoFont = { fontFamily: "'GT Pressura Mono', monospace" };

const PageLoading = ({ message = 'Loading', showSidebar = true }) => {
  const content = (
    <main className="flex-1 flex items-center justify-center">
      <div className="text-center">
        <div className="w-12 h-12 border border-[rgba(255,251,247,0.2)] border-t-[#a1c6a2] animate-spin mx-auto" />
        <p
          className="mt-6 text-[10px] text-[rgba(255,251,247,0.5)] tracking-[0.2em] uppercase"
          style={monoFont}
        >
          {message}
        </p>
      </div>
    </main>
  );

  if (showSidebar) {
    return (
      <div className="flex h-screen bg-black">
        <Sidebar />
        {content}
      </div>
    );
  }

  return (
    <div className="flex items-center justify-center h-screen bg-black">
      <div className="text-center">
        <div className="w-12 h-12 border border-[rgba(255,251,247,0.2)] border-t-[#a1c6a2] animate-spin mx-auto" />
        <p
          className="mt-6 text-[10px] text-[rgba(255,251,247,0.5)] tracking-[0.2em] uppercase"
          style={monoFont}
        >
          {message}
        </p>
      </div>
    </div>
  );
};

export default PageLoading;
